import { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useTheme } from "../context/ThemeContext";

const ADMIN_CHART_THEME_DARK = {
  chart: {
    backgroundColor: "transparent",
    plotBackgroundColor: "rgba(255, 255, 255, 0.03)",
  },
  title: { style: { color: "#f1f5f9" } },
  subtitle: { style: { color: "#b8c5d6" } },
  xAxis: {
    labels: { style: { color: "#c4d0de" } },
    lineColor: "rgba(255, 255, 255, 0.14)",
    tickColor: "rgba(255, 255, 255, 0.14)",
    gridLineColor: "rgba(255, 255, 255, 0.07)",
    title: { style: { color: "#e2e8f0" } },
  },
  yAxis: {
    labels: { style: { color: "#c4d0de" } },
    lineColor: "rgba(255, 255, 255, 0.14)",
    tickColor: "rgba(255, 255, 255, 0.14)",
    gridLineColor: "rgba(255, 255, 255, 0.08)",
    title: { style: { color: "#e2e8f0" } },
  },
  legend: {
    itemStyle: { color: "#e2e8f0" },
    itemHoverStyle: { color: "#f8fafc" },
  },
  tooltip: {
    backgroundColor: "rgba(8, 12, 28, 0.96)",
    borderColor: "rgba(255, 255, 255, 0.16)",
    style: { color: "#f1f5f9" },
  },
};

const ADMIN_CHART_THEME_LIGHT = {
  chart: {
    backgroundColor: "transparent",
    plotBackgroundColor: undefined,
  },
};

export function isAdminDarkTheme(theme) {
  return theme === "dark";
}

export function mergeAdminChartOptions(options, dark) {
  if (!options || typeof options !== "object") return options;
  const base = dark ? ADMIN_CHART_THEME_DARK : ADMIN_CHART_THEME_LIGHT;
  return Highcharts.merge(base, options);
}

export function chartFluidBase(dark) {
  return {
    reflow: true,
    width: null,
    style: { maxWidth: "100%" },
    spacingLeft: 2,
    spacingRight: 2,
    spacingTop: 6,
    spacingBottom: 4,
    backgroundColor: "transparent",
    plotBackgroundColor: dark ? "rgba(255, 255, 255, 0.03)" : undefined,
  };
}

export function adminPieCenterLabelColor(dark) {
  return dark ? "#f1f5f9" : "#0f172a";
}

export function AdminHighcharts({ options, containerProps, ...rest }) {
  const { theme } = useTheme();
  const dark = isAdminDarkTheme(theme);
  const themed = useMemo(() => mergeAdminChartOptions(options, dark), [options, dark]);

  return (
    <HighchartsReact
      key={theme}
      highcharts={Highcharts}
      options={themed}
      containerProps={containerProps}
      {...rest}
    />
  );
}
